module.exports = __webpack_public_path__ + "img/metrics_blue.0be6cb9d.svg";